import { api } from '@/global/services/api'
import { isObject } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import documentsHistoryHelper from '../documents-history-helper'
import { notify } from '@/global/services/notification/notificationBus'
import tabsHelper from '../tabs-helper'

const DOCUMENTS_HISTORY_DATA_KEY = 'solutionDocuments'
const DOCUMENT_TYPE = 'ruling'
export default {

  mixins: [
    documentsHistoryHelper,
    tabsHelper
  ],

  data () {
    return {
      solutionHistoryVisible: false,
      solutionShowEditButtons: false,
      solutionEditState: false,
      solutionShowDocumentPreview: false,
      solutionDocument: null,
      solutionDataForGenerationVisible: true,
      solutionTitle: this.$t('road-maintenance/aggregator.solution'),
      solutionBaseTitle: this.$t('road-maintenance/aggregator.solution'),
      solutionValidationErrors: {},
      solutionDocumentHistoryLoaded: false,
      solutionsRefreshDisabled: false,
      solutionsDocumentLoaders: [],
      showSolutionTabLoader: null
    }
  },

  computed: {
    solutionConfig () {
      return {
        title: this.$t('road-maintenance/aggregator.solution'),
        visible: this.$route.query.category !== 'request_new',
        key: 'solution',
        validationErrors: this.solutionValidationErrors,
        apiConfig: {
          post: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}/store`,
            usePatch: false,
            method: 'post'
          },
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}`,
            method: 'get'
          }
        },
        edit: this.solutionEditState,
        editUpdate: (event) => this.onSolutionEditUpdate(event),
        dataFetched: (event) => this.onSolutionDataFetched(event),
        afterCancel: (event) => this.onSolutionDataFetched(event),
        afterSave: (event) => this.onSolutionDataFetched(event, true),
        modifyDataBeforeSend: (event) => this.onSolutionModifyData(event),
        showLoader: this.showSolutionTabLoader,
        hiddenFormKeys: [
          'html'
        ],
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.solutionTitle,
            showBackButton: {
              onGoBack: () => this.goBack()
            },
            showEditButtons: this.solutionShowEditButtons,
            forceAdditionalButtonsDisplay: true,
            additional_buttons: [
              {
                type: 'base',
                appendIcon: 'mdi-refresh',
                visible: !this.solutionShowEditButtons,
                disabled: this.solutionsRefreshDisabled,
                click: async (event) => {
                  const { fetchTabData } = event || {}
                  this.solutionsRefreshDisabled = true

                  await fetchTabData?.()
                  await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

                  setTimeout(() => {
                    this.solutionsRefreshDisabled = false
                  }, this.refreshTabBtnTimeout)
                }
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                visible: !this.solutionShowEditButtons && !!this.permissions?.canChangeStatus,
                click: (event) => this.onChangeStatus(event)
              },
              {
                type: 'dropdown',
                buttonType: 'base',
                label: this.$t('road-maintenance/aggregator.generate_document'),
                color: '#65AD45',
                class: 'generate-document-btn',
                visible: !this.solutionShowEditButtons && !!this.permissions?.canCreate,
                menuContentClass: 'menu-class',
                component: this.documentsGenerationDropdownMenuComponent,
                hasHistoryData: this.logsData?.[DOCUMENTS_HISTORY_DATA_KEY]?.length,
                menuItemClick: (event) => this.solutionMenuItemClick(event)
              },
              {
                type: 'base',
                label: this.viewPdfBtnLabel,
                color: '#6e736d',
                visible: this.solutionShowEditButtons,
                class: 'generate-document-btn',
                loaderConfig: {
                  opacity: 0,
                  color: '#FFFFFFF'
                },
                showLoader: this.showPreviewLoader,
                click: (event) => this.previewDocument(event, DOCUMENT_TYPE, this.solutionBaseTitle)
              }
            ],
            onCancelTabSave: () => this.onSolutionCancelTab(),
            onSaveClick: (event) => this.onSolutionSave(event)
          },
          // Data for document generation
          {
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.data_for_solution_generation'),
            visible: this.solutionDataForGenerationVisible,
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'doc_class',
                    label: this.$t('road-maintenance/aggregator.class'),
                    row: 1,
                    column: 1,
                    colSpan: 1,
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'registry_number',
                    row: 1,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/excavation-service/tabs/approval/columns.registration_number'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'created_at',
                    type: 'datetime-picker',
                    subType: 'date',
                    row: 1,
                    column: 3,
                    colSpan: 1,
                    appendIcon: 'mdi-calendar',
                    format: FORMATS.date,
                    placeholder: FORMATS.date,
                    label: this.$t('road-maintenance/aggregator.document_date'),
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          created_at: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false
                  },
                  {
                    key: 'applicant',
                    row: 2,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/prp.request_applicant'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'addresses',
                    row: 2,
                    column: 2,
                    colSpan: 2,
                    label: this.$t('road-maintenance/aggregator.request_locations'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'work_type',
                    type: 'textarea',
                    row: 3,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.type_of_works_or_actions'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'regulation_setter',
                    row: 3,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/codebook_type.regulation_setter'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_name',
                    row: 3,
                    column: 3,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_name'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_responsible',
                    row: 4,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_responsible_person'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_phone',
                    row: 4,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_phone'),
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_email',
                    row: 4,
                    column: 3,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_email'),
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    type: 'plain-text',
                    text: this.$t('road-maintenance/aggregator.solution_valid'),
                    row: 5,
                    column: 1,
                    colSpan: 1.5,
                    class: 'time-period-text',
                    colClass: 'time-period-column',
                    visible: true
                  },
                  {
                    type: 'plain-text',
                    text: this.$t('road-maintenance/aggregator.requested_date_from_request'),
                    row: 5,
                    column: 2,
                    colSpan: 1.5,
                    class: 'time-period-text',
                    colClass: 'time-period-column',
                    visible: true
                  },
                  {
                    key: 'valid_from',
                    type: 'datetime-picker',
                    row: 6,
                    column: 1,
                    colSpan: 0.75,
                    appendIcon: 'mdi-calendar',
                    format: FORMATS.datetimeShort,
                    placeholder: FORMATS.datetimeShort,
                    label: this.$t('road-maintenance/aggregator.datetime_from'),
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.datetimeShort, true)) {
                        updateValidationErrors({
                          valid_from: this.$t('base.invalid_date').replace(':format', FORMATS.datetimeShort)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false
                  },
                  {
                    key: 'valid_to',
                    type: 'datetime-picker',
                    row: 6,
                    column: 1,
                    colSpan: 0.75,
                    appendIcon: 'mdi-calendar',
                    format: FORMATS.datetimeShort,
                    placeholder: FORMATS.datetimeShort,
                    label: this.$t('road-maintenance/aggregator.datetime_to'),
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.datetimeShort, true)) {
                        updateValidationErrors({
                          valid_to: this.$t('base.invalid_date').replace(':format', FORMATS.datetimeShort)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false
                  },
                  {
                    key: 'date_time_from',
                    row: 6,
                    column: 2,
                    colSpan: 0.75,
                    appendIcon: 'mdi-calendar',
                    label: this.$t('road-maintenance/aggregator.date_from'),
                    onInput: (value, event) => {
                      const { updateData, formData } = event || {}
                      if (value && typeof updateData === 'function' && !formData.valid_from) {
                        updateData({
                          valid_from: value
                        })
                      }
                    },
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'date_time_to',
                    row: 6,
                    column: 2,
                    colSpan: 0.75,
                    appendIcon: 'mdi-calendar',
                    label: this.$t('road-maintenance/aggregator.date_to'),
                    onInput: (value, event) => {
                      const { updateData, formData } = event || {}
                      if (value && typeof updateData === 'function' && !formData.valid_to) {
                        updateData({
                          valid_to: value
                        })
                      }
                    },
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'amendments',
                    type: 'textarea',
                    row: 7,
                    column: 1,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.supplement_to_solution'),
                    unlock: !!this.permissions?.canCreate,
                    creatable: true,
                    editable: true,
                    visible: true,
                    doubleClickEdit: false
                  },
                  {
                    key: 'document_delivery_participants',
                    type: 'textarea',
                    row: 7,
                    column: 2,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.other_solution_participants'),
                    unlock: !!this.permissions?.canCreate,
                    creatable: true,
                    editable: true,
                    visible: true,
                    doubleClickEdit: false
                  }
                ]
              }
            ]
          },
          // Document history
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            title: this.$t('road-maintenance/aggregator.log_history'),
            visible: this.solutionHistoryVisible,
            externalData: this.logsData,
            dataKey: DOCUMENTS_HISTORY_DATA_KEY,
            columnsConfig: [
              {
                key: 'created_at',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.date') + ':',
                customValue: (data) => {
                  return data?.created_at ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.datetimeShort) : ''
                }
              },
              {
                key: 'status',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance/excavation-service.status') + ':',
                customValue: (data) => {
                  return data?.status ? this.$t(data.status) : '-'
                }
              },
              {
                key: 'user',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.user') + ':'
              },
              {
                key: 'document',
                valueClass: 'history-block-value',
                visible: (event) => {
                  return event?.blockValue !== '-'
                },
                loaderIds: this.solutionsDocumentLoaders,
                title: this.$t('road-maintenance/aggregator.document') + ':',
                prependImage: {
                  src: '/img/icons/pdf-icon.svg',
                  style: {
                    marginRight: '4%'
                  }
                },
                contentWrapperStyle: {
                  display: 'flex',
                  alignItems: 'center'
                },
                customValue: (data) => {
                  return data?.document?.name ? data.document.name : '-'
                },
                click: (event) => this.onSolutionsDownloadDocument(event)
              },
              {
                visible: (event) => {
                  return !!event?.rowData?.document_data_id
                },
                component: this.createFromVersionBtnComponent,
                class: 'create-from-version-btn-block',
                onClick: (event) => this.onSolutionCreateFromVersion(event)
              }
            ]
          },
          {
            component: this.documentPreviewComponent,
            visible: this.solutionShowDocumentPreview,
            content: this.solutionDocument
          }
        ]
      }
    }
  },

  methods: {
    async onSolutionsDownloadDocument (event) {
      const { id: documentId } = event?.rowData || {}
      // skip if download is already in progress
      if (this.solutionsDocumentLoaders.includes(documentId)) {
        return
      }
      // show document loader
      if (documentId && !this.solutionsDocumentLoaders.includes(documentId)) {
        this.solutionsDocumentLoaders.push(documentId)
      }

      // download document
      await this.downloadDocument(event)
      // stop document loader
      if (this.solutionsDocumentLoaders.includes(documentId)) {
        this.solutionsDocumentLoaders = this.solutionsDocumentLoaders.filter(activeLoaderId => activeLoaderId !== documentId)
      }
    },

    async onSolutionGenerateDocument (event, showLast = false) {
      try {
        const { formData } = event || {}
        const { id } = this?.$route?.params || {}
        this.showSolutionTabLoader = true

        // validate data
        if (!id) {
          notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
          console.error('Missing traffic regulation id')
          return
        }
        if (!isObject(formData)) {
          notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
          console.error('Form data is invalid', formData)
          return
        }

        // Create formData object for sending
        const dataToSend = new FormData()
        dataToSend.append('amendments', formData?.amendments ?? '')
        dataToSend.append('document_delivery_participants', formData?.document_delivery_participants ?? '')
        dataToSend.append('valid_from', formData?.valid_from ? dateService.formatCustom(formData.valid_from, FORMATS.datetimeShort, FORMATS.isoDatetime) : '')
        dataToSend.append('valid_to', formData?.valid_to ? dateService.formatCustom(formData.valid_to, FORMATS.datetimeShort, FORMATS.isoDatetime) : '')
        dataToSend.append('created_at', formData?.created_at ? dateService.formatCustom(formData.created_at, FORMATS.date, FORMATS.isoDate) : '')
        dataToSend.append('show_last_version', showLast)

        // Get document html
        const { data } = await api('road-maintenance').post(`traffic-regulation/${id}/${DOCUMENT_TYPE}`, dataToSend)

        this.solutionDocument = data
        this.solutionShowDocumentPreview = true
        this.solutionEditState = true
        this.solutionShowEditButtons = true
        this.solutionDataForGenerationVisible = false
        this.solutionTitle = this.$t('road-maintenance/aggregator.solution_document_overview')
      }
      catch (exception) {
        const { errors } = exception?.response?.data || {}
        this.solutionValidationErrors = errors && isObject(errors) ? errors : {}
        console.error(exception)
      }
      finally {
        this.showSolutionTabLoader = false
      }
    },

    async onSolutionCreateFromVersion (event) {
      try {
        this.showSolutionTabLoader = true

        // get document data
        const data = await this.createFromVersion(event, DOCUMENT_TYPE)

        const { html, css } = data || {}
        // do not open document if data is invalid
        if (!html && !css) {
          return
        }

        // set document data and open document preview
        this.solutionDocument = data
        this.solutionShowDocumentPreview = true
        this.solutionEditState = true
        this.solutionShowEditButtons = true
        this.solutionDataForGenerationVisible = false
        this.solutionTitle = this.$t('road-maintenance/aggregator.solution_document_overview')
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        this.showSolutionTabLoader = false
      }
    },

    onSolutionCancelTab () {
      this.$set(this.informationDialogConfig, 'title', this.$t('base.warning'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'cancelButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.data_not_saved_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', () => this.solutionCancel())
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    solutionCancel () {
      this.solutionEditState = false
      this.$set(this.informationDialogConfig, 'showDialog', false)
    },

    onSolutionSave (event) {
      const { saveTab } = event || {}
      this.$set(this.informationDialogConfig, 'title', this.$t('base.warning'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'cancelButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'message', this.$t('road-maintenance/aggregator.document_will_be_uploaded_to_centrix_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', () => this.onSolutionSaveConfirmation(saveTab))
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    onSolutionSaveConfirmation (saveTabFn) {
      if (typeof saveTabFn === 'function') {
        saveTabFn()
      }

      this.solutionEditState = false
      this.$set(this.informationDialogConfig, 'showDialog', false)
      this.$set(this.informationDialogConfig, 'title', this.informationDialogBaseConfig.title)
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', this.informationDialogBaseConfig.confirmCallbackFunction)
    },

    onSolutionEditUpdate (event) {
      const { edit } = event || {}
      this.solutionHistoryVisible = !edit

      if (!edit) {
        this.solutionShowDocumentPreview = false
        this.solutionEditState = false
        this.solutionShowEditButtons = false
        this.solutionDataForGenerationVisible = true
        this.solutionDocument = null
        this.solutionTitle = this.solutionBaseTitle
      }
    },

    async onSolutionDataFetched (event, afterSave = false) {
      const { data: apiData, updateData } = event || {}
      const { formDataForSend } = event || {}

      const data = apiData?.data || formDataForSend || {}

      if (typeof updateData === 'function' && data && isObject(data)) {
        updateData({
          // Update contractor
          contractor_name: data?.contractor?.name ?? null,
          contractor_responsible: data?.contractor?.responsible_person ?? null,
          contractor_phone: data?.contractor?.phone ?? null,
          contractor_email: data?.contractor?.email ?? null,
          created_at: data?.created_at && !dateService.isValid(data.created_at, FORMATS.date, true) ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.date) : dateService.now(FORMATS.date),

          // Regulation setter
          regulation_setter: data?.regulation_setter?.description ? this.$t(data.regulation_setter.description) : null,

          // datetime from and to
          date_time_from: data?.date_time_from ? dateService.formatCustom(data.date_time_from, FORMATS.isoDatetime, FORMATS.datetimeShort) : null,
          date_time_to: data?.date_time_to ? dateService.formatCustom(data.date_time_to, FORMATS.isoDatetime, FORMATS.datetimeShort) : null,
          valid_from: data?.valid_from ? dateService.formatCustom(data.valid_from, FORMATS.isoDatetime, FORMATS.datetimeShort) : null,
          valid_to: data?.valid_to ? dateService.formatCustom(data.valid_to, FORMATS.isoDatetime, FORMATS.datetimeShort) : null
        })
      }

      if (!this.solutionDocumentHistoryLoaded || afterSave) {
        this.solutionDocumentHistoryLoaded = true
        const { id: suggestedStatusId, description } = data?.suggested_status || {}

        // Fetch documents logs
        await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

        // Open change status popup after documents save only if we have suggested status provided
        if (suggestedStatusId) {
          this.$set(this.afterDocumentStatusChangeActions, 'statusId', suggestedStatusId)
          const message = this.$t('road-maintenance/aggregator.status_change_message')
          this.$set(this.informationDialogConfig, 'showDialog', afterSave)
          this.$set(this.informationDialogConfig, 'message', '<div> ' + message + '<span style="font-style: italic; color: green;">' + ' ' + this.$t(description) + '</span>?</div>')
        }
      }
    },

    onSolutionModifyData (event) {
      const { originalData } = event || {}

      if (originalData) {
        originalData.created_at = originalData?.created_at ? dateService.formatCustom(originalData.created_at, FORMATS.date, FORMATS.isoDate) : null
        originalData.valid_from = originalData?.valid_from ? dateService.formatCustom(originalData.valid_from, FORMATS.datetimeShort, FORMATS.isoDatetime) : null
        originalData.valid_to = originalData?.valid_to ? dateService.formatCustom(originalData.valid_to, FORMATS.datetimeShort, FORMATS.isoDatetime) : null
      }

      return originalData
    },

    async solutionMenuItemClick (event) {
      const { menuIndex } = event || {}
      await this.onSolutionGenerateDocument(event, menuIndex === 1)
    }
  }
}
